var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5C18.9609 5 14.1282 7.00178 10.565 10.565C7.00178 14.1282 5 18.9609 5 24C5 29.0391 7.00178 33.8718 10.565 37.435C14.1282 40.9982 18.9609 43 24 43C29.0391 43 33.8718 40.9982 37.435 37.435C40.9982 33.8718 43 29.0391 43 24C43 18.9609 40.9982 14.1282 37.435 10.565C33.8718 7.00178 29.0391 5 24 5Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.572 29.036H31.489L32.261 24.041H26.571V21.311C26.571 19.236 27.249 17.396 29.19 17.396H32.309V13.037C31.761 12.963 30.602 12.801 28.412 12.801C23.839 12.801 21.158 15.216 21.158 20.718V24.041H16.457V29.036H21.158V42.765C22.089 42.905 23.032 43 24 43C24.875 43 25.729 42.92 26.572 42.806V29.036Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0138d60cf79de5092e3b03432d849747.svg";
export { ForwardRef as ReactComponent };